import { Get } from '../http/httpVerbs';
import { returnEnvironment } from '../utils';
import { apiGetCommunityCreator } from './apiGetCommunityCreator';

export const apiGetCreator = async (id) => {
    try {
        // fetch Community data if on wizard environment
        // TODO add a more robust and generic check for communities
        if (returnEnvironment() === "wizard") {
            const communityCreator = await apiGetCommunityCreator(id);
            return communityCreator;
        }

        const creator = await Get(`${process.env.REACT_APP_API_URL}/creators/${id}`);
        return creator;
    } catch (error) {
        throw error;
    }
};
